import Vue from 'vue'
import { GET_GOOGLE_TOKEN } from 'src/vuex/mutation-types'
import { getGoogleAuthUrl, getGoogleAuthCode, getGoogleAuthToken } from 'src/utils/googleAuth'

export const login = ({ state, dispatch }) => {
  return new Promise((resolve, reject) => {
    getGoogleAuthUrl()
      .then(url => getGoogleAuthCode(url))
      .then(code => getGoogleAuthToken(code))
      .then(token => {
        dispatch(GET_GOOGLE_TOKEN, token)
        resolve(token)
      })
  })
}

export const logout = ({ state, dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http.get('google-logout', { params: { token: state.google.token } })
      .then(
        response => {
          dispatch(GET_GOOGLE_TOKEN, null)
          resolve()
        },
        response => reject()
      )
  })
}

export const checkTokenFromSession = ({ dispatch }) => {
  return new Promise((resolve, reject) => {
    if (window.localStorage.getItem('GOOGLE_TOKEN')) {
      dispatch(GET_GOOGLE_TOKEN, window.localStorage.getItem('GOOGLE_TOKEN'))
      resolve()
    }
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/googleActions.js